const UTM_STORAGE_KEY = 'base-dev-utm-params';

type UTMParams = {
  source?: string;
  medium?: string;
  campaign?: string;
};

type ReferralSource = {
  utm: UTMParams;
};

export function captureUTMParams(): void {
  if (typeof window === 'undefined') return;

  const searchParams = new URLSearchParams(window.location.search);
  const source = searchParams.get('utm_source');
  const medium = searchParams.get('utm_medium');
  const campaign = searchParams.get('utm_campaign');

  if (source || medium || campaign) {
    const params: UTMParams = {};
    if (source) params.source = source;
    if (medium) params.medium = medium;
    if (campaign) params.campaign = campaign;
    sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(params));
  }
}

export function getReferralSource(): ReferralSource | undefined {
  if (typeof window === 'undefined') return undefined;

  const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
  if (!stored) return undefined;

  try {
    const params = JSON.parse(stored) as UTMParams;
    if (params.source || params.medium || params.campaign) {
      return { utm: params };
    }
    return undefined;
  } catch {
    return undefined;
  }
}

export function getUtmSource(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
  if (!stored) return undefined;
  try {
    const params = JSON.parse(stored) as UTMParams;
    return params.source;
  } catch {
    return undefined;
  }
}
